import { useDispatch } from "react-redux"
import { actions } from "store"
import { alerts } from "keys"

const useAlert = () => {
    const dispatch = useDispatch()

    return (val, props) => {
        dispatch(actions.setAlerts({
            key: alerts.downloadStudentFile,
            value: { open: val, props: props || null }
        }))
    }
}

export default useAlert